import QuoteBox from "./Components/QuoteBox/QuoteBox";
import "./App.css";

function App() {
  return (
    <div className="App">
      <QuoteBox />
    </div>
  );
}

export default App;
